/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PidSimulationContestationResponse
 */
export interface PidSimulationContestationResponse {
    /**
     * 
     * @type {string}
     * @memberof PidSimulationContestationResponse
     */
    gpCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PidSimulationContestationResponse
     */
    xmlRequest?: string;
}

/**
 * Check if a given object implements the PidSimulationContestationResponse interface.
 */
export function instanceOfPidSimulationContestationResponse(value: object): value is PidSimulationContestationResponse {
    return true;
}

export function PidSimulationContestationResponseFromJSON(json: any): PidSimulationContestationResponse {
    return PidSimulationContestationResponseFromJSONTyped(json, false);
}

export function PidSimulationContestationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PidSimulationContestationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'gpCode': json['gpCode'] == null ? undefined : json['gpCode'],
        'xmlRequest': json['xmlRequest'] == null ? undefined : json['xmlRequest'],
    };
}

export function PidSimulationContestationResponseToJSON(json: any): PidSimulationContestationResponse {
    return PidSimulationContestationResponseToJSONTyped(json, false);
}

export function PidSimulationContestationResponseToJSONTyped(value?: PidSimulationContestationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gpCode': value['gpCode'],
        'xmlRequest': value['xmlRequest'],
    };
}

